/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Element ui
import './plugins/elementui';
// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
import "@/plugins/moment.js"

import "@/fontawesome-free-5.9.0-web/css/all.css";
Vue.use(Vuesax)
Vue.use(require('vue-shortkey'))
import {
  initialize
} from '@/plugins/general.js';
initialize(store, router);
import SimplePrint from 'simply-print-vue';

// axios
import axios from "./axios.js"
Vue.prototype.$http = axios
const options = {
  name: "_blank",
  specs: [
    "fullscreen=no",
    // 'titlebar=yes',
    // 'scrollbars=yes'
  ],
  // "autoClose": no,
  timeout: 100,
  autoClose: true,
  styles: [
    "https://pos-qa.mongz-cashier.com/css/80Print.css",
    // `${baseURL}`,
    // 'http://127.0.0.1:82/css/print.css',
    // 'http://127.0.0.1:8000/css/80Print.css',
    // 'http://192.168.1.5:2020/css/80Print.css',

    // 'http://192.168.1.5:2020/css/print.css',

    // "http://167.172.157.191:2022/css/print.css"
  ],
};
Vue.use(SimplePrint, options);

// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
// import { VueHammer } from 'vue2-hammer'
// Vue.use(VueHammer)


// PrismJS
// import 'prismjs'
// import 'prismjs/themes/prism-tomorrow.css'

import '@/plugins/bootstrap.js';

// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
